var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaqCanvasCopyPaste = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4145_3500)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#BBDFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4145_3500",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#BB1919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4145_3500)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.375 23.375V20.5406C23.375 19.7279 23.3749 19.0268 23.4221 18.4493C23.4719 17.8398 23.5819 17.2336 23.8791 16.6503C24.3225 15.78 25.03 15.0725 25.9003 14.6291C26.4836 14.3319 27.0898 14.2219 27.6993 14.1721C28.2768 14.1249 28.9778 14.125 29.7905 14.125H35.4594C36.272 14.125 36.9732 14.1249 37.5507 14.1721C38.1602 14.2219 38.7664 14.3319 39.3497 14.6291C40.22 15.0725 40.9275 15.78 41.3709 16.6503C41.6681 17.2336 41.7781 17.8398 41.8279 18.4493C41.875 19.0268 41.875 19.7278 41.875 20.5405V26.2094C41.875 27.0221 41.875 27.7232 41.8279 28.3007C41.7781 28.9102 41.6681 29.5164 41.3709 30.0997C40.9275 30.97 40.22 31.6775 39.3497 32.1209C38.7664 32.4181 38.1602 32.5281 37.5507 32.5779C36.9732 32.6251 36.2721 32.625 35.4594 32.625L32.625 32.625V35.4594C32.625 36.2721 32.6251 36.9732 32.5779 37.5507C32.5281 38.1602 32.4181 38.7664 32.1209 39.3497C31.6775 40.22 30.97 40.9275 30.0997 41.3709C29.5164 41.6681 28.9102 41.7781 28.3007 41.8279C27.7232 41.8751 27.0222 41.875 26.2096 41.875H20.5406C19.728 41.875 19.0268 41.8751 18.4493 41.8279C17.8398 41.7781 17.2336 41.6681 16.6503 41.3709C15.78 40.9275 15.0725 40.22 14.6291 39.3497C14.3319 38.7664 14.2219 38.1602 14.1721 37.5507C14.125 36.9732 14.125 36.2721 14.125 35.4595V29.7906C14.125 28.9779 14.125 28.2768 14.1721 27.6993C14.2219 27.0898 14.3319 26.4836 14.6291 25.9003C15.0725 25.03 15.78 24.3225 16.6503 23.8791C17.2336 23.5819 17.8398 23.4719 18.4493 23.4221C19.0268 23.3749 19.7279 23.375 20.5406 23.375H23.375ZM32.625 29.5417C32.6245 28.834 32.6202 28.217 32.5779 27.6993C32.5281 27.0898 32.4181 26.4836 32.1209 25.9003C31.6775 25.03 30.97 24.3225 30.0997 23.8791C29.5164 23.5819 28.9102 23.4719 28.3007 23.4221C27.783 23.3798 27.166 23.3755 26.4583 23.375V20.6C26.4583 19.7111 26.4595 19.1372 26.4952 18.7004C26.5294 18.2816 26.5875 18.1263 26.6264 18.0501C26.7742 17.76 27.01 17.5242 27.3001 17.3764C27.3763 17.3375 27.5316 17.2794 27.9504 17.2452C28.3872 17.2095 28.9611 17.2083 29.85 17.2083L35.4 17.2083C36.2889 17.2083 36.8628 17.2095 37.2996 17.2452C37.7184 17.2794 37.8737 17.3375 37.9499 17.3764C38.24 17.5242 38.4758 17.76 38.6236 18.0501C38.6625 18.1263 38.7206 18.2816 38.7548 18.7004C38.7905 19.1372 38.7917 19.7111 38.7917 20.6L38.7917 26.15C38.7917 27.0389 38.7905 27.6128 38.7548 28.0496C38.7206 28.4684 38.6625 28.6237 38.6236 28.6999C38.4758 28.99 38.24 29.2258 37.9499 29.3736C37.8737 29.4125 37.7184 29.4706 37.2996 29.5048C36.8628 29.5405 36.2889 29.5417 35.4 29.5417L32.625 29.5417Z",
    fill: "#1463BB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3500",
    x: -4.5,
    y: 1.5,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4145_3500"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0 0.141176 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3500",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4145_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaqCanvasCopyPaste);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/faq_canvas_copy_paste.68ac1e3e8bffd10de950f0b8cf39ce73.svg";